export default function recommendationCategoryUniqueNameDirective(
  $q,
  amSharedModelService
) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link,
  };

  function link(scope, element, attributes, ngModel) {
    const auditId = attributes.auditId || -1;
    const recommendationCategoryId = attributes.recommendationCategoryId || -1;

    ngModel.$asyncValidators.amRecommendationCategoryUniqueName = modelValue => amSharedModelService
      .checkRecommendationCategoryExists(auditId, recommendationCategoryId, modelValue)
      .then((nameExists) => {
        if (!nameExists) {
          return $q.resolve();
        }
        return $q.reject();
      })
      .catch(() => $q.reject());
  }
}

export const name = 'amRecommendationCategoryUniqueName';

recommendationCategoryUniqueNameDirective.$inject = [
  '$q',
  'amSharedModelService'
];
